import { useEffect, useRef, useState } from 'react';
import { getLabel } from '../../../data/labels';
import Loader from '../../../common/Loader';
import { useFetchCheckbetTicket } from '../../fetchCheckbetTicket';
import { formatDate, getCheckbetUrl, getConfiguration, getCurrencySymbol, getPrintableAmount } from '../../utils';
import TupleInfo from '../TupleInfo';
import EventsList from './EventsList';
import ReloadTicketSection from './ReloadTicketSection';
import SocialShareButtons from './SocialShareButtons';
import Winnings from './Winnings';
import ToggleNotifications from './ToggleNotifications';

function SystemBetsTicket(props) {
    const conf = getConfiguration();
    const currency = getCurrencySymbol(conf.cs.ct);
    const initialFetchDone = useRef(false);
    const ticketUrl = getCheckbetUrl(props.ticket.id);

    useEffect(() => {
        if (props.index && !props.toggled) {
            props.toggleTicket(props.ticket.id);
        }
    }, []);

    const [state, setState] = useState({
        data: null,
        eventsToggled: false,
        tuplesInfoToggled: false,
        update(updt) {
            setState(prev => {
                return { ...prev, ...updt };
            });
        },
        setData(data) {
            this.update({ data });
        },
        toggleEvents() {
            this.update({ eventsToggled: !this.eventsToggled });
        },
        toggleTuplesInfo() {
            this.update({ tuplesInfoToggled: !this.tuplesInfoToggled });
        },
        reset() {
            this.update({ eventsToggled: false, tuplesInfoToggled: false });
        }
    });

    const [request, dispatch] = useFetchCheckbetTicket(props.ticket.id, !initialFetchDone.current || state.eventsToggled || state.tuplesInfoToggled, props.ticket.isLive, false, true);

    useEffect(() => {
        if (request.data != null && !request.isError) {
            state.setData(request.data);
            initialFetchDone.current = true;
        }
    }, [request.data, request.isError]);

    useEffect(() => {
        if (state.data != null && !props.toggled) {
            state.reset();
        }
    }, [props.toggled]);

    function toggleEvents() {
        state.toggleEvents();
        if (!state.tuplesInfoToggled) {
            props.toggleTicket(props.ticket.id);
        }
    }

    function toggleTuplesInfo() {
        state.toggleTuplesInfo();
        if (!state.eventsToggled) {
            props.toggleTicket(props.ticket.id);
        }
    }

    const showEvents = props.toggled && state.eventsToggled;
    const showTuplesInfo = props.toggled && state.tuplesInfoToggled;

    const getEsitoClass = function (eventStatus, winning, winningDrawCode) {
        if (eventStatus === 'voided') {
            return 'esito-vd';
        }
        if (!['winning', 'losing'].includes(eventStatus) || !winningDrawCode) {
            return 'esito-nd';
        }
        return winning ? 'esito-v' : 'esito-p';
    }

    return (
        <div className="mybet-container d-flex flex-column | mb_5">
            <div className="d-flex justify-content-space-between align-items-center margine-su-giu bold pointer details-toggle | mb_5_1" onClick={toggleEvents}>
                <span className="text-big | mb_5_1_1">{getLabel('mybets.sistema')}  <span className='mybet__counter'>({props.ticket.eventsCount})</span></span>

                <span className="margine-sx margin-right-auto | mb_5_1_2">
                    {props.ticket.funBonus &&
                        <span className="cg-mybet-funbonus | mb_5_1_2_1">{getLabel('mybets.funbonus')}</span>
                    }
                    {props.ticket.freeBet &&
                        <span className="cg-mybet-funbonus | mb_5_1_2_2">{getLabel('mybets.freebet')}</span>
                    }
                </span>
                <span className="mb_5_1_3" onClick={toggleEvents}>
                    <i className={`mb_5_1_3__${showEvents ? 'less' : 'more'}`}></i>
                </span>
            </div>
            <div className='mybet-container__event-list__wrapper'>
                {state.data == null ?
                    <Loader error={request.isError} />
                    :
                    state.data.events.map((event, i) => {
                        return event.bets.map((bet, i) => {
                            return <div key={i} className="event-list__outcome-symbol">
                                <span className={"esito | mb_10_3_2_1_3 " + getEsitoClass(bet.state, bet.isWinning, bet.winningDrawCode)}></span>
                            </div>
                        })
                    }
                    )}
            </div>
            <hr className="mb_4" />
            {showEvents &&
                (state.data == null ?
                    <Loader error={request.isError} />
                    :
                    <div className="mybet-events-container | mb_6">
                        {conf.pnc?.enabled && <ToggleNotifications state={state} dispatch={dispatch} />}
                        <EventsList events={state.data.events} isSystem={true} isCheckbet={props.isCheckbet} />
                    </div>
                )
            }
            <div className="light-grey-bg | mb_5_3">
                <div className="bet-info d-flex justify-content-space-between align-items-center | mb_5_3_1">
                    <div className="d-flex flex-column text-small | mb_5_3_1_1">
                        <span className="grey | mb_5_3_1_1_1">{getLabel('mybets.importo')}</span>
                        <span className="text-medium bold | mb_5_3_1_1_2">{getPrintableAmount(props.ticket.amount, conf.cs.m, conf.cs.nd)} {currency}</span>
                    </div>
                    <div className="d-flex flex-column text-small | mb_5_3_1_1">
                        <span className="grey | mb_5_3_1_1_1">{getLabel('mybets.quotatotale')}</span>
                        <span className="text-medium bold | mb_5_3_1_1_2">{getLabel('mybets.nondisponibile')}</span>
                    </div>
                    <Winnings {...props.ticket} />
                    <div className='button__ticket__wrapper'>
                        <SocialShareButtons ticketUrl={ticketUrl} />
                        {props?.ticket?.status === 'opened' && <ReloadTicketSection isCheckbet={props.isCheckbet} ticket={props.ticket} />}
                    </div>
                </div>
                <hr className="mb_4" />
                <div className="d-flex justify-content-space-between align-items-center margin-top text-small grey pointer tuples-toggle | mb_8">
                    <div className="d-flex justify-content-space-between | mb_8_1">
                        <span className="mb_8_1_1">{getLabel('mybets.sistema')}</span>
                        &nbsp;
                        <span className="mb_8_1_1" onClick={toggleTuplesInfo}>{`(${getLabel('mybets.dettagli')} ${showTuplesInfo ? '-' : '+'})`}</span>
                    </div>
                    <div className="d-flex justify-content-space-between | mb_8_2">
                        <span className="mb_8_2_1">Ref. {props.ticket.id}</span>
                        <span className="margin-left-right | mb_8_2_2">|</span>
                        <span className="mb_8_2_3">{formatDate(props.ticket.timestamp).formatted}</span>
                    </div>
                </div>
            </div>
            {showTuplesInfo &&
                (state.data == null ?
                    <Loader error={request.isError} />
                    :
                    <div id="tuples-info" className="light-grey-bg | mb_9">
                        <TupleInfo tuples={state.data.tuples} ticketId={props.ticket.id} />
                    </div>
                )
            }
        </div>
    );
}

export default SystemBetsTicket;